export default {
    selectAll: 'Seleccionar todos',
    next: 'Siguiente',
    discard: 'Descartar',
    close: 'Cerrar',
    cancel: 'Cancelar',
    search: 'Buscar',
    apply: 'Aplicar',
    confirm: 'Confirmar',

    retry: {
        text: 'An error ocurred.',
        link: 'Click here to try again',
    },
}
